// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VC7m","content":"styles_content__3v4rF","tableWrap":"styles_tableWrap__3m7lm"};